<template>
    <v-dialog v-model="isOpen" width="800">
        <template v-slot:activator="{ on }">
            <div @click="isOpen = true">
                <v-select v-show="show" :value="selectedContacts" :items="selectedContactsFull" :loading="isLoading" multiple item-value="email" label="Contacts" background-color="white" hide-details readonly outlined dense v-on="on">
                    <template v-slot:selection="data">
                        <v-chip v-if="data.index === 0" small label>
                            <v-avatar class="blue white--text text-uppercase" left size="16">
                                {{ data.item.name.slice(0, 1) }}
                            </v-avatar>
                            <span v-if="data.item.name || data.item.name">
                                {{ data.item.name }} {{ data.item.firstname }}
                            </span>
                            <span v-else>
                                <i> Sans nom </i>
                            </span>
                        </v-chip>

                        <span v-if="data.index === 1" class="grey--text text-caption">
                            (+{{ selectedContacts.length - 1 }} autres)
                        </span>
                    </template>

                    <template v-slot:item="{ item }">
                        <v-list-item-avatar class="blue white--text text-uppercase headline">
                            {{ item.name.slice(0, 1) }}
                        </v-list-item-avatar>

                        <v-list-item-content>
                            <v-list-item-title>
                                <span v-if="item.name || item.name">
                                    {{ item.name }} {{ item.firstname }}
                                </span>
                                <span v-else>
                                    <i> Sans nom </i>
                                </span>
                            </v-list-item-title>

                            <v-list-item-subtitle>
                                <span v-if="item.email">
                                    {{ item.email }}
                                </span>
                                <span v-else>
                                    <i> Sans email </i>
                                </span>
                                -
                                <span v-if="item.mobile">
                                    {{ item.mobile }}
                                </span>
                                <span v-else>
                                    <i> Sans portable </i>
                                </span>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </template>
                </v-select>
            </div>
        </template>

        <v-card>
            <v-toolbar dense flat>
                <v-toolbar-title class="title primary--text">
                    Sélection de contacts
                </v-toolbar-title>

                <v-spacer />

                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn @click="isOpen = false" color="primary" icon v-on="on">
                            <v-icon> far fa-times-circle </v-icon>
                        </v-btn>
                    </template>
                    Fermer la fenêtre
                </v-tooltip>
            </v-toolbar>

            <v-divider />

            <v-card-text class="pt-4">
                <v-text-field v-model="search" label="Recherche" class="mb-4" hide-details outlined dense />

                <ProgramAutocomplete ref="programAutocomplete" :disabled="typeof initProgramId === 'number'" class="mb-4" v-model="programId" label="Programme" noDynamicSearch />

                <v-row>
                    <v-col cols="6">
                        <div class="d-flex align-center justify-space-between">
                            <h4> Contacts sélectionnés </h4>

                            <v-spacer />

                            <v-btn v-show="selectedContactsFull.length > 0" color="primary" @click="deselectAll()" x-small> Tout Désélectionner </v-btn> <br>
                        </div>

                        <v-list>
                            <v-list-item v-for="(contact, i) of selectedContactsFull" :key="i + '_' + contact.email + '_selected'" @click="removeContact(contact)" :class="{ 'cursor-not-allowed': !canDeleteContact(contact) }">
                                <v-list-item-avatar class="white--text text-uppercase" size="25" color="blue">
                                    {{ contact.name[0] }}
                                </v-list-item-avatar>

                                <v-list-item-content class="py-0">
                                    <v-list-item-title class="subtitle-2">
                                        <div class="d-flex align-center">
                                            <div class="flex-grow-1 text-truncate" style="min-width: 0;">
                                                {{ contact.name }} {{ contact.firstname }}
                                            </div>
                                            <v-chip v-if="contact.connectionsCount === 0" class="ml-2" color="red lighten-4" label x-small>
                                                Non connecté
                                            </v-chip>
                                        </div>
                                    </v-list-item-title>

                                    <v-list-item-subtitle>
                                        <v-chip class="mr-1" :class="{ 'cursor-pointer': canDeleteContact(contact), 'cursor-not-allowed': !canDeleteContact(contact) }" small label>
                                            {{ contact.program.title }} - <span class="ml-1"> {{ contact.product.reference }} - {{ contact.product.type }} </span>
                                        </v-chip>
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-col>

                    <v-divider vertical class="my-4" />

                    <v-col cols="6">
                        <div class="d-flex align-center justify-space-between">
                            <h4> Recherche </h4>

                            <v-spacer />

                            <v-btn v-show="searchContacts.length > 0" color="primary" @click="selectAll()" x-small> Tout sélectionner </v-btn> <br>
                        </div>

                        <v-list>
                            <v-list-item v-for="(contact, i) of searchContacts" :key="contact.email +  '_search_' + i" @click="addContact(contact)">
                                <v-list-item-avatar class="white--text text-uppercase" size="25" color="grey">
                                    {{ contact.name[0] }}
                                </v-list-item-avatar>

                                <v-list-item-content class="py-0">
                                    <v-list-item-title class="subtitle-2">
                                        <div class="d-flex align-center">
                                            <div class="flex-grow-1 text-truncate" style="min-width: 0;">
                                                {{ contact.name }} {{ contact.firstname }}
                                            </div>
                                            <v-chip v-if="contact.connectionsCount === 0" class="ml-2" color="red lighten-4" label x-small>
                                                Non connecté
                                            </v-chip>
                                        </div>
                                    </v-list-item-title>

                                    <v-list-item-subtitle>
                                        <v-chip class="mr-1 cursor-pointer" x-small label>
                                            {{ contact.program.title }} - <span class="ml-1"> {{ contact.product.reference }} - {{ contact.product.type }} </span>
                                        </v-chip>
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn @click="submit()" color="primary" small>
                    Valider
                </v-btn>

                <v-spacer />

                <v-btn @click="cancel()" small>
                    Annuler
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import ProgramAutocomplete from '../widgets/ProgramAutocomplete.vue';

export default {
    name: 'ContactAutocomplete',

    components: {
        ProgramAutocomplete
    },

    props: {
        value: {},
        show: { type: Boolean, default: true },
        fixedContacts: { type: Array },
        initProgramId: { type: Number },
        returnSaleId: { type: Boolean, default: false }
    },

    data: () => ({
        isOpen: false,
        selectedContacts: [],
        selectedContactsFull: [],

        programId: null,
        programsFetched: false,

        searchContacts: [],
        isLoading: false,
        search: null,
        searchTimeout: null,

        initSelectedContacts: [],
        initSelectedContactsFull: []
    }),

    watch: {
        isOpen() {
            if (this.isOpen) {
                if (this.initProgramId) {
                    this.programId = this.initProgramId;
                }
    
                if (!this.programsFetched) {
                    this.programsFetched = true;
                    this.$nextTick(() => {
                        this.$refs.programAutocomplete.fetchPrograms({ limit: 1000 });
                    });   
                }
            }
        },

        search() {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                if (typeof this.search !== 'string' || this.search.length.length < 3) {
                    return;
                }
                this.makeSearch();
            }, 500);
        },

        programId() {
            this.makeSearch();
        },

        value() {
            this.selectedContacts = this.value;
            this.init();
        }
    },

    methods: {
        open() {
            this.isOpen = true;
        },

        submit() {
            this.isOpen = false;
            if (this.returnSaleId) {
                this.$emit('input', this.selectedContactsFull.map((c) => c.saleId));
            } else {
                this.$emit('input', this.selectedContacts);
            }
        },

        async init() {
            if ((Array.isArray(this.selectedContacts) && this.selectedContacts.length > 0) || typeof this.selectedContacts === 'number') {
                const contacts = Array.isArray(this.selectedContacts) ? this.selectedContacts : [this.selectedContacts];
                this.selectedContactsFull = await this.fetchContacts({ limit: 10000, emails: contacts });
                this.initSelectedContactsFull = JSON.parse(JSON.stringify(this.selectedContactsFull));
                this.initSelectedContacts = JSON.parse(JSON.stringify(this.selectedContacts));
            } else {
                this.selectedContacts = [];
                this.selectedContactsFull = [];
            }
        },

        canDeleteContact(contact) {
            if (Array.isArray(this.fixedContacts)) {
                return !this.fixedContacts.includes(contact.email);
            }

            return true;
        },

        addContact(contact) {
            const existing = this.selectedContactsFull.find((c) => c.email === contact.email);
            if (existing) {
                return;
            }

            this.selectedContacts.push(contact.email);
            const contacts = this.searchContacts.filter((c) => c.email === contact.email);
            this.selectedContactsFull.push(...contacts);

            this.searchContacts = this.searchContacts.filter((c) => c.email !== contact.email);
        },

        removeContact(contact) {
            if (!this.canDeleteContact(contact)) {
                return;
            }

            const contacts = this.selectedContactsFull.filter((c) => c.email === contact.email);
            this.searchContacts.push(...contacts);
            this.searchContacts.sort((a, b) => a.name.localeCompare(b.name));

            this.selectedContactsFull = this.selectedContactsFull.filter((c) => c.email !== contact.email);
            this.selectedContacts = this.selectedContacts.filter((email) => email !== contact.email);
        },

        selectAll() {
            for (const contact of this.searchContacts) {
                this.addContact(contact);
            }
        },

        deselectAll() {
            const copy = JSON.parse(JSON.stringify(this.selectedContactsFull));
            for (const contact of copy) {
                this.removeContact(contact);
            }
        },

        cancel() {
            this.selectedContacts = this.initSelectedContacts;
            this.selectedContactsFull = this.initSelectedContactsFull;
            this.isOpen = false;
        },

        async makeSearch() {
            if (this.isLoading) {
                return;
            }

            if (!this.search && !this.programId) {
                this.searchContacts = [];
                return;
            }

            const query = { limit: 5 };

            if (this.search) {
                query.quickSearch = this.search;
            }

            if (this.programId) {
                query.limit = 10000;
                query.programs = this.programId;
            }

            this.setLoading(true);
            this.searchContacts = [];
            
            const contacts = await this.fetchContacts(query);
            for (const contact of contacts) {
                if (!this.selectedContacts.includes(contact.email)) {
                    this.searchContacts.push(contact);
                }
            }
            this.setLoading(false);
        },

        async fetchContacts(query) {
            try {
                this.isLoading = true;
                const { contacts } = await this.repos.contacts.getContacts2(query);
                return contacts;
            } catch (err) {
                console.error(err);
                return [];
            } finally {
                this.isLoading = false;
            }
        }
    },

    created() {
        if (this.value) {
            this.selectedContacts = JSON.parse(JSON.stringify(this.value));
        }

        this.init();
    }
};
</script>